import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "fee896b7-fadf-4499-b0d0-1efe7d1910a2",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "Input the resistance of the slit rounded to the nearest integer:",
    suffixText: "kPa s/m<sup>3</sup>",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 130560,
};
